import { Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { IconPercent, RuleContent, RuleDescription, RuleIcon, Tag } from 'ui'
import { messages } from '../messages'
import { useNumbers } from 'ui/components/utils/useNumbers'

type BenefitProps = {
  value: number
}

export function PercentualBenefit(props: BenefitProps) {
  const { value } = props
  const { $t } = useIntl()
  const { formatPercentual } = useNumbers()

  return (
    <>
      <RuleIcon>
        <IconPercent />
      </RuleIcon>
      <RuleDescription>
        {$t(messages.benefit.percentualTitle, {
          b: (content) => <Text variant="body">{content}</Text>,
        })}
      </RuleDescription>
      <RuleContent>
        <Tag>{formatPercentual(value)}</Tag>
      </RuleContent>
    </>
  )
}
